import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react'
import React from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../services/api'

async function ativarRotinas({ codigoVendedor, validaRotina }) {
  const response = await api.post(`/site/v2/crm-controle/desliga-rotina-vendedor`, {
    codigo_vendedor: codigoVendedor,
    valida_rotina: validaRotina,
  })

  return response.data
}

export function AtivarRotinas({ codigoVendedor, nomeVendedor }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (data) => ativarRotinas(data),
    onError: (error, variables, context) => {
      console.log(error)
    },
    onSuccess: (data, variables, context) => {
      console.log(data)
      queryClient.invalidateQueries('controle-rodizio')
      onClose()

      toast({
        title: 'Rotinas alteradas com sucesso',
        status: 'success',
      })
    },
  })

  async function handleAtivarRotinas() {
    const params = {
      codigoVendedor,
      validaRotina: 'S',
    }
    try {
      await mutateAsync(params)
    } catch (error) {
      console.log(error)
    }
  }

  async function handleDesativarRotinas() {
    const params = {
      codigoVendedor,
      validaRotina: 'N',
    }
    try {
      await mutateAsync(params)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Button colorScheme="green" onClick={onOpen} size="sm">
        Ativar/Desativar Rotinas
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} size="xl">
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Ativar/Desativar Rotinas para o Vendedor{' '}
              <Text textTransform="capitalize" as="span">
                {nomeVendedor}
              </Text>
            </AlertDialogHeader>
            <AlertDialogBody>
              Deseja realmente Ativar/Desativar as rotinas para o vendedor{' '}
              <Text textTransform="capitalize" as="span">
                {nomeVendedor}
              </Text>
              ?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>

              <Button colorScheme="green" onClick={handleAtivarRotinas} ml={3}>
                08:30 - 17:00
              </Button>
              <Button colorScheme="red" onClick={handleDesativarRotinas} ml={3}>
                09:30 - 19:00
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
